/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import './calendar.css';
import moment from 'moment';
import DayjsUtils from '@date-io/dayjs';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '@/app/store/actions';
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useState, useEffect, useRef } from 'react';
import { getRooms, getAllRooms } from '@/app/services/rooms/rooms';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import { useReactToPrint } from 'react-to-print';
import { TextField, Typography, Avatar, Select, MenuItem, FormControl } from '@material-ui/core';
import { DatePicker as MuiDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { getEvents } from '@/app/services/events/events';
import WeeklyCalendar from './WeeklyCalendar';
import DailyCalendar from './DailyCalendar';
import MonthlyCalendar from './MonthlyCalendar';
import PageHeader from '@/app/customComponents/PageHeader';
import PageContainer from '@/app/customComponents/PageContainer';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';

const CalendarView = () => {
	const ref = useRef(null);
	const dispatch = useDispatch();
	const [week, setWeek] = useState(() => []);
	const [rooms, setRooms] = useState([]);
	const [selectedRoom, setSelectedRoom] = useState(null);
	const [isRoomLoading, setIsRoomLoading] = useState(false);
	const [searchRoomQuery, setSearchRoomQuery] = useState('');
	const [currentView, setCurrentView] = useState('month'); // week | day | month
	const [events, setEvents] = useState([]);
	const [isLoadingEvents, setIsLoadingEvents] = useState(false);
	const user = useSelector(({ auth }) => auth.user);
	const [refresh, setRefresh] = useState(false);

	const componentToPrint = useRef(null);

	useEffect(() => {
		let isMounted = true;
		setIsLoadingEvents(true);
		if (week[0]) {
			getEvents(week[0]?.format('YYYY-MM-DD'), week[week.length - 1]?.format('YYYY-MM-DD'), selectedRoom)
				.then((res) => {
					if (!isMounted) return;
					setEvents(res.data);
				})
				.catch((err) => {
					if (!isMounted) return;
					console.log(err);
				})
				.finally(() => {
					if (!isMounted) return;
					setIsLoadingEvents(false);
				});
		}
		return () => {
			isMounted = false;
		};
	}, [week, selectedRoom, refresh]);

	useEffect(() => {
		setEvents([]);
		if (currentView === 'week') {
			const d = moment(new Date()).startOf('week');
			const newWeek = [];
			for (let i = 0; i < 7; i += 1) {
				newWeek.push(moment(d.add(1, 'days')));
			}
			setWeek(newWeek);
		}
		if (currentView === 'day') {
			setWeek([moment(new Date())]);
		}
		if (currentView === 'month') {
			const d = moment(new Date()).startOf('month').startOf('week');
			const newWeek = [];
			for (let i = 0; i < 35; i += 1) {
				newWeek.push(moment(d.add(1, 'days')));
			}
			setWeek(newWeek);
		}
	}, [currentView]);

	useEffect(() => {
		let isMounted = true;
		setIsRoomLoading(true);
		setRooms([]);
		if (!searchRoomQuery) {
			getAllRooms()
				.then(({ data }) => {
					if (!isMounted) return;
					setRooms(data);
				})
				.catch(() => {
					if (!isMounted) return;
					dispatch(
						Actions.showMessage({
							message: 'Failed to fetch data, please refresh',
							variant: 'error',
						}),
					);
				})
				.finally(() => {
					if (!isMounted) return;
					setIsRoomLoading(false);
				});
		} else {
			getRooms(searchRoomQuery, searchRoomQuery ? undefined : 1)
				.then(({ data }) => {
					if (!isMounted) return;
					setRooms(data.data);
				})
				.catch(() => {
					if (!isMounted) return;
					dispatch(
						Actions.showMessage({
							message: 'Failed to fetch data, please refresh',
							variant: 'error',
						}),
					);
				})
				.finally(() => {
					if (!isMounted) return;
					setIsRoomLoading(false);
				});
		}
		return () => {
			isMounted = false;
		};
	}, [searchRoomQuery]);

	const handlePrint = useReactToPrint({
		content: () => componentToPrint.current,
	});

	const handleWeekChange = (changeNumber) => {
		if (currentView === 'week') {
			const newWeekArray = [];
			for (let i = 0; i < 7; i += 1) {
				const date = new Date(week[i]);
				newWeekArray[i] = moment(new Date(date.setDate(date.getDate() + changeNumber)));
			}
			setWeek(newWeekArray);
		}
		if (currentView === 'day') {
			setWeek([moment(week[0].add(changeNumber, 'days'))]);
		}
		if (currentView === 'month') {
			const d = week[15].add(changeNumber, 'month').startOf('month').startOf('week');
			const newWeek = [];
			for (let i = 0; i < 35; i += 1) {
				newWeek.push(moment(d.add(1, 'days')));
			}
			setWeek(newWeek);
		}
	};

	const handleCalendarDateChange = (date) => {
		if (currentView === 'week') {
			date = new Date(date.format('YYYY-MM-DD'));
			const newWeek = [];
			for (let i = 0; i < 7; i += 1) {
				newWeek[i] = moment(new Date(moment(date).add(i, 'days')));
			}
			setWeek(newWeek);
		}
		if (currentView === 'day') {
			setWeek([moment(new Date(date))]);
		}
		if (currentView === 'month') {
			const d = moment(new Date(date)).startOf('month').startOf('week');
			const newWeek = [];
			for (let i = 0; i < 35; i += 1) {
				newWeek.push(moment(d.add(1, 'days')));
			}
			setWeek(newWeek);
		}
	};
	const handleView = (e) => {
		const { value } = e.target;
		setCurrentView(value);
	};

	const handleTimeBack = () => {
		handleWeekChange(currentView === 'week' ? -7 : -1);
	};

	const handleTimeForward = () => {
		handleWeekChange(currentView === 'week' ? 7 : 1);
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<PageContainer>
				<div className="flex justify-between items-center">
					<PageHeader hasBack={false} title="Calendar" />
					<CustomButton height="40" onClick={handlePrint} variant="secondary" width="80px">
						<i aria-hidden="true" className="fa fa-print" /> Print
					</CustomButton>
				</div>
				<div className="flex flex-col">
					<Autocomplete
						autoComplete={false}
						className="sm:w-320 sm:self-end"
						clearOnBlur={false}
						fullWidth
						getOptionLabel={(option) => option.name}
						id="rooms"
						loading={isRoomLoading}
						loadingText="...Loading"
						onChange={(_e, v) => {
							setSelectedRoom(v?.id);
						}}
						options={rooms}
						renderInput={(params) => (
							<TextField
								{...params}
								autoComplete="off"
								label="Room"
								onChange={(e) => setSearchRoomQuery(e.target.value)}
							/>
						)}
						renderOption={(option) => {
							return (
								<div className="flex items-center gap-10">
									<Avatar src={option.thumb} />
									<div>{option.name}</div>
								</div>
							);
						}}
						sx={{ width: '100%' }}
					/>
				</div>

				<div className="bg-white rounded-8 my-32 p-8 sm:p-16 md:p-32">
					<div className="flex justify-between flex-col-reverse gap-16 md:flex-row">
						<div className="flex px-16 sm:px-0 justify-between sm:justify-center sm:gap-32 items-center ">
							<button
								className="h-40 w-40 border-pd-blue rounded-full border-2 hover:shadow-lg"
								onClick={handleTimeBack}
								type="button"
							>
								<ChevronLeft className="text-pd-blue" />
							</button>

							<span
								className="font-extrabold"
								onClick={() => ref.current.click()}
								style={{ fontSize: '15px', margin: '0 15px', cursor: 'pointer', lineHeight: '2.2' }}
							>
								{currentView === 'week' ? (
									<p>
										{week[6] ? moment.months()[new Date(week[3]).getMonth()] : ''}, {new Date(week[3]).getFullYear()}
									</p>
								) : null}
								{currentView === 'day' ? <p>{week[0].format('DD[, ]MMMM[ ] YYYY')}</p> : null}
								{currentView === 'month' ? (
									<p>
										{week[15] ? moment.months()[new Date(week[15])?.getMonth()] : ''},{' '}
										{new Date(week[15]).getFullYear()}
									</p>
								) : null}
							</span>
							<button
								className="h-40 w-40 border-pd-blue rounded-full border-2 hover:shadow-lg"
								onClick={handleTimeForward}
								type="button"
							>
								<ChevronRight className="text-pd-blue " />
							</button>
						</div>

						<div style={{ alignSelf: 'flex-end' }}>
							<FormControl>
								<Select
									id="view"
									name="filter"
									onChange={handleView}
									startAdornment={
										<>
											{currentView === 'day' ? <img className="cursor-pointer" src="assets/images/day.png" /> : null}
											{currentView === 'week' ? <img className="cursor-pointer" src="assets/images/week.png" /> : null}
											{currentView === 'month' ? (
												<img className="cursor-pointer" src="assets/images/month.png" />
											) : null}
										</>
									}
									style={{ width: 150, gap: 10 }}
									value={currentView}
								>
									<MenuItem value="day">
										<span id="day">Day</span>
									</MenuItem>
									<MenuItem value="week">
										<span id="week">Week</span>
									</MenuItem>
									<MenuItem value="month">
										<span id="month">Month</span>
									</MenuItem>
								</Select>
							</FormControl>
						</div>
						<MuiPickersUtilsProvider utils={DayjsUtils}>
							<MuiDatePicker
								disabled={false}
								format="dd/MM/yyyy"
								inputRef={ref}
								maxDate={moment().add(1, 'years').format('MM/DD/YYYY')}
								minDate={moment().subtract(2, 'months').format('MM/DD/YYYY')}
								onChange={(date) => handleCalendarDateChange(date)}
								style={{ display: 'none' }}
								views={currentView === 'month' ? ['month', 'year'] : ['year', 'month', 'date']}
							/>
						</MuiPickersUtilsProvider>
					</div>

					<div className="mt-28">
						{currentView === 'week' ? (
							<WeeklyCalendar
								events={events}
								loading={isLoadingEvents}
								refresh={refresh}
								setRefresh={setRefresh}
								week={week}
							/>
						) : null}
						{currentView === 'day' ? (
							<DailyCalendar
								events={events}
								loading={isLoadingEvents}
								refresh={refresh}
								setRefresh={setRefresh}
								week={week}
							/>
						) : null}
						{currentView === 'month' ? (
							<MonthlyCalendar
								events={events}
								loading={isLoadingEvents}
								refresh={refresh}
								setRefresh={setRefresh}
								setWeek={setWeek}
								week={week}
							/>
						) : null}
					</div>
				</div>
				<div className="hidden">
					<div className="p-16" ref={componentToPrint}>
						<div className="flex flex-row justify-between">
							<div>
								<img src="assets/images/logos/logo.png" />
							</div>
							<div style={{ textAlign: 'right' }}>
								<Typography variant="subtitle1">
									<span style={{ display: 'block', marginBottom: '-0.7em', writingMode: '' }}>
										{user.school?.address || user.data?.school?.address}
									</span>{' '}
									<span>
										{user.school?.city || user.data?.school?.city},{' '}
										{user.school?.state?.name || user.data?.school?.state?.name}{' '}
										{user.school?.zip_code || user.data?.school?.zip_code}
									</span>
								</Typography>
								<Typography variant="subtitle1">{user.school?.phone || user.data?.school?.phone}</Typography>
								<Typography variant="subtitle1">{user.email}</Typography>
							</div>
						</div>
						<div style={{ marginBottom: '20px' }}>
							<h3>
								<strong>Calendar Events</strong>
							</h3>
							<span>
								<strong>Date: </strong>
							</span>
							<span>{currentView === 'day' ? week[0].format('dddd, DD MMMM YYYY') : week[6]?.format('MMMM YYYY')}</span>
						</div>
						<div className="mt-28">
							{currentView === 'week' ? (
								<WeeklyCalendar events={events} loading={isLoadingEvents} printView={true} week={week} />
							) : null}
							{currentView === 'day' ? (
								<DailyCalendar events={events} loading={isLoadingEvents} printView={true} week={week} />
							) : null}
							{currentView === 'month' ? (
								<MonthlyCalendar
									events={events}
									loading={isLoadingEvents}
									printView={true}
									setCurrentView={setCurrentView}
									setWeek={setWeek}
									week={week}
								/>
							) : null}
						</div>
					</div>
				</div>
			</PageContainer>
		</FuseAnimate>
	);
};

export default CalendarView;
